<template>
  <router-view />
</template>
<script>
import _ from 'lodash'
import { getUserInfo } from '@/api/account'

export default {
  name: 'MobileLayout',
  components: {
  },
  data () {
    return {
      permission: [],
      collapsed: false,
      menus: []
    }
  },
  beforeRouteEnter (to, from, next) {
    getUserInfo()
      .then(res => {
        if (_.get(res, 'code') === 200) {
          next()
        } else {
          var par = window.location.search
          window.location.href = '/merchant/login' + par + '&path=' + window.location.pathname
        }
      })
  },
  methods: {
  }
}
</script>
